module.exports = __webpack_public_path__ + "media/img/frontend_application/free_trial/venuerific_logo-1a3637b20458f0a9f8b4f05caeb41d09.png";